export default __webpack_public_path__ + "static/media/image.f-code-labs-private-limited.c175e75c.png";